/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import Img from "gatsby-image/withIEPolyfill"

const slideImage = ({ fluid, alt }) => (
  <Img
    sx={{ position: "absolute !important", height: "100%", width: "100%" }}
    fluid={fluid}
    alt={alt}
  />
)

slideImage.propTypes = {
  fluid: PropTypes.object.isRequired,
  alt: PropTypes.string,
}

export default slideImage
